module.exports = __webpack_public_path__ + "img/setting.2dfa500b.svg";